import React, { Component } from 'react'
import { Alert, Row, Col, Button, ListGroup, ListGroupItem } from 'react-bootstrap'
import StatusMessage from "../../lib/statusmessage"
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, stateFromHTML, ContentState, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import MyDropzone from "./my-support-dropzone";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default class MySupportEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            attachments: [],
            Alert: null,
            uploading: false,
            clearAlerts: null
        }
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.onUploadFailed = this.onUploadFailed.bind(this);
        this.onUploading = this.onUploading.bind(this);
        this.appendHTMLToEditor = this.appendHTMLToEditor.bind(this);
        this.removeAttachment = this.removeAttachment.bind(this);
        this.submit = this.submit.bind(this);
        this.reset = this.reset.bind(this);
        this.MyDropzoneRef = React.createRef();
    }

    onEditorStateChange = (_editorState) => {
        this.setState({
            editorState: _editorState
        })
    }

    reset = () => {
        this.setState({
            editorState: EditorState.createEmpty(),
            attachments: [],
        })
    }

    submit = async () => {
        this.clearAlerts()
        if (!this.state.editorState.getCurrentContent().hasText()) {
            this.setState({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `${"Please enter a reply."}`
                })

            })
            this.props.onSubmitAttempt();
        } else {
            //await this.addReply();
            await this.props.onSubmit(draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())), this.state.attachments);
        }
    }

    clearAlerts() {
        this.setState({ Alert: null });
        this.MyDropzoneRef.current.clearAlerts();
    }


    onUpload = async (upload) => {
        //this.appendHTMLToEditor(`<p>[attachment=${upload.attachment.FileName}]</p>`);
        this.setState({
            attachments: [...this.state.attachments, upload],
            uploading: false
        })
    }

    onUploadFailed = async (error) => {
        this.setState({
            Alert: new StatusMessage({
                Status: "danger",
                Message: `${error.errors[0].message || "This file can not be accepted."}`,
            }),
            uploading: false
        })
    }

    onUploading = async () => {
        this.setState({
            uploading: true
        })
    }

    appendHTMLToEditor = async (text) => {
        console.log(this.state.editorState.getCurrentContent());
        EditorState.moveFocusToEnd(this.state.editorState);
        let currentHTML = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
        currentHTML = currentHTML + text;
        const blocksFromHTML = convertFromHTML(currentHTML);
        const state = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap,
        );

        this.setState({
            editorState: EditorState.push(this.state.editorState, state, 'insert-fragment')
        })
    }

    removeAttachment = async (attachment) =>{
        let _attachments = this.state.attachments;
        _attachments = _attachments.filter(x=>{ 
            return x.attachment.AttachmentId !== attachment.attachment.AttachmentId
        });

        this.setState({
            attachments: _attachments
        })
    }

    render() {
        return (
            <div className={`my-support-editor`}>
                <Row>
                    <Col>
                        {this.state.Alert &&
                            <Alert dismissible variant={this.state.Alert.Status}>
                                {this.state.Alert.Message}
                            </Alert>
                        }
                    </Col>
                </Row>
                <Row className={`editor`}> <Col>
                    <Editor
                        editorState={this.state.editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        spellCheck="true"
                        onEditorStateChange={this.onEditorStateChange}
                        toolbar=
                        {{
                            options: ['inline', 'blockType', 'list', 'link', 'emoji', 'remove', 'history'],
                            inline: {

                                options: ['bold', 'italic', 'underline', 'strikethrough'],
                            },
                            blockType: {
                                inDropdown: false,
                                options: ['Code'],
                                className: undefined,
                                component: undefined,
                                dropdownClassName: undefined,
                            },
                        }}
                    />
                </Col>
                </Row>
                <Row>
                    <Col>
                        {
                            (() => {
                                if (this.state.attachments.length>0) {
                                    return (
                                        <>
                                            <h4>Attachments</h4>
                                            <ListGroup variant={`flush`}>
                                                {(() => {
                                                    return this.state.attachments.map((attachment) => {
                                                        return <ListGroupItem><Button bsPrefix={`b`} variant={`outline-dark`} size={`sm`} onClick={() => this.removeAttachment( attachment)}><i class={`fa fa-close`}></i></Button>  {attachment?.attachment?.FileName || "file"}</ListGroupItem>

                                                    })
                                                })()}

                                            </ListGroup>
                                        </>
                                    )

                                }

                            })()
                        }

                    </Col>
                </Row>
                <Row >
                    <Col>
                        <MyDropzone ref={this.MyDropzoneRef} onUpload={this.onUpload} onUploading={this.onUploading} onUploadFailed={this.onUploadFailed} />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Button onClick={this.submit} disabled={this.props.disabledSubmit || this.state.uploading || !this.state.editorState.getCurrentContent().hasText() || false}>Submit {this.state.Loading && <div><i className="fa fa-spinner fa-spin"></i></div>}</Button>
                    </Col>
                </Row>
            </div>
        )
    }
}